import { IBaseWidget } from '../../IBaseWidget';
import { WidgetRepository } from '../WidgetRepository';
import { IInputWidget } from './IInputWidget';

export function isInputWidget(widget: IBaseWidget): widget is IInputWidget {
  return WidgetRepository.find(widget.type)?.hasValue ?? false;
}
